import * as constants from './constants'

const INITIAL_STATE = {
  loading: false,
  saveLoading: false,
  sponsors: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  sponsor: {},
  sponsorResponse: {},
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return Object.assign({}, state, {
        loading: action.data
      })
    case constants.SET_SAVE_LOADING:
      return Object.assign({}, state, {
        saveLoading: action.data
      })
    case constants.SET_SPONSORS:
      return Object.assign({}, state, {
        sponsors: action.data
      })
    case constants.SET_SPONSOR:
      return Object.assign({}, state, {
        sponsor: action.data
      })
    case constants.SET_SPONSOR_RESPONSE:
      return Object.assign({}, state, {
        sponsorResponse: action.data
      })
    default: return state
  }
}
